import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accident-reporting',
  templateUrl: './accident-reporting.component.html',
  styleUrls: ['./accident-reporting.component.css'],
})
export class AccidentReportingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
